import { getCurrentInstance } from '@nuxtjs/composition-api';

const getContext = () => {
  const vm = getCurrentInstance();
  return vm.root.proxy;
};
const useUiHelpers = (): any => {
  const context = getContext();
  const getFacetsFromURL = () => {

    const { query } = context.$router.currentRoute;
    const categorySlug = context.$router.currentRoute.params.slug_1;
    return {
      categorySlug,
      isFirstCat: context.$router.currentRoute.params.slug_3,
      catId: categorySlug,
      subCatId: query.sc,
      page: parseInt(query.page as string, 10) || 1,
      limit: parseInt(query.limit as string, 10) || 10,
      sort: query.sort
    } as any;
  };

  // eslint-disable-next-line
  const getCatLink = (catId, slug, scId, subCat): string => {
    let path = '/c/';
    if (subCat?.isSub) {
      path += subCat.catId;
      if (slug) {
        path += '/' + slug;
      }
      if (scId) {
        path += '?sc=' + scId;
      }
    } else {
      path += catId;
      if (slug) {
        path += '/' + slug;
      }
      if (scId) {
        path += '?sc=' + scId;
      }
    }
    return path;
  };

  // eslint-disable-next-line
  const changeSorting = (sort) => {
    const { path, query } = context.$router.currentRoute;
    const paths = {
      path: path,
      query: { sc: undefined, sort: sort }
    };
    if (query.sc) {
      paths.query.sc = query.sc;
    }
    context.$router.push(paths);
  };

  // eslint-disable-next-line
  const changeFilters = (filters) => {
    console.warn('[VSF] please implement useUiHelpers.changeFilters.');
  };

  // eslint-disable-next-line
  const changeItemsPerPage = (itemsPerPage) => {
    console.warn('[VSF] please implement useUiHelpers.changeItemsPerPage.');
  };

  // eslint-disable-next-line
  const setTermForUrl = (term: string) => {
    console.warn('[VSF] please implement useUiHelpers.changeSearchTerm.');
  };

  // eslint-disable-next-line
  const isFacetColor = (facet): boolean => {
    console.warn('[VSF] please implement useUiHelpers.isFacetColor.');

    return false;
  };

  // eslint-disable-next-line
  const isFacetCheckbox = (facet): boolean => {
    console.warn('[VSF] please implement useUiHelpers.isFacetCheckbox.');

    return false;
  };

  const getSearchTermFromUrl = () => {
    console.warn('[VSF] please implement useUiHelpers.getSearchTermFromUrl.');
  };
  const getArtcleLink = (article_id): string => {
    let path = '';
    if (article_id) {
      path = '/a/' + article_id;
    }
    return path;
  };
  return {
    getFacetsFromURL,
    getCatLink,
    changeSorting,
    changeFilters,
    changeItemsPerPage,
    setTermForUrl,
    isFacetColor,
    isFacetCheckbox,
    getSearchTermFromUrl,
    getArtcleLink
  };
};

export default useUiHelpers;
